export default "__VITE_ASSET__79243d5c__"